export interface DashboardHeaderProps {
  title: string;
  description: string;
  className?: string;
}

/**
 * Dashboard header component for analytics dashboard
 * Provides title and description
 */
export function DashboardHeader({ title, description, className = '' }: DashboardHeaderProps) {
  return (
    <div className={`border-b border-border/40 pb-4 ${className}`}>
      <div className="space-y-1">
        <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
        <p className="text-sm text-muted-foreground">{description}</p>
      </div>
    </div>
  );
}
